export default __webpack_public_path__ + "static/media/img1.eb6008f7.jpg";